import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let url = location.pathname;

  return (
    <>
      <div className="h-[1150px] w-1/4 bg-white rounded-xl shadow-md pb-4">
        <div className="mb-6">
          <div className="w-full h-24 bg-gray-200">
            <img
              src="https://placehold.co/600x400"
              alt="cover"
              className="w-full h-24 object-cover"
            />
          </div>
          <div className="absolute -mt-4 ml-2 w-24 h-24 rounded-none mb-6">
            <img
              src="https://placehold.co/100x100"
              alt="profile"
              className="w-24 h-24 rounded-none border-4 border-white -mt-12 ml-4 mb-6"
            />
          </div>
        </div>

        <div className="">
          <div className="p-4">
            <div className="mb-4">
              <h1 className="text-3xl font-bold">
                LogicSpice Consultancy Pvt. Ltd.
              </h1>
              <p className="text-sm text-gray-600">3,559 followers</p>
            </div>
            <button className="w-fit bg-blue-600 text-white py-1 px-6 rounded-full mb-4">
              <i class="fas fa-plus"></i> Create
            </button>
            <button className="w-fit border border-gray-400 text-gray-700 py-1 px-6 rounded-full mb-4">
              <i class="fas fa-eye"></i> View as member
            </button>
          </div>

          <div className="grid grid-cols-1 space-y-2">
            <Link
              to="/company/dashboard"
              className={`flex items-center text-gray-700 ${
                url === "/company/dashboard"
                  ? "border-l-4 border-green-600"
                  : ""
              }`}
            >
              <span className="mr-1 ml-4">🏠</span> <p className={`py-3 text-gray-700 ${
                url === "/company/dashboard"
                  ? "text-green-600"
                  : ""
              }`}>Dashboard</p>
            </Link>
            <Link
              to="/company/page-posts"
              className={`flex items-center text-gray-700 ${
                url === "/company/page-posts"
                  ? "border-l-4 border-green-600"
                  : ""
              }`}
            >
              {/* <span className="mr-1 ml-4"></span>  */}
              <span className="mr-1 ml-4">📝</span> <p className={`py-3 text-gray-700 ${
                url === "/company/page-posts"
                  ? "text-green-600"
                  : ""
              }`}>Page posts</p>
            </Link>
            <Link
              to="#"
              className={`py-3 text-gray-700 ${
                url === "/company/analytics"
                  ? "border-l-4 border-green-600"
                  : ""
              }`}
            >
              <span className="mr-1 ml-4">📊</span> Analytics
            </Link>
            <Link
              to="#"
              className={`py-3 text-gray-700 ${
                url === "/company/feed" ? "border-l-4 border-green-600" : ""
              }`}
            >
              <span className="mr-1 ml-4">🔔</span> Feed
            </Link>
            <Link
              to="/company/inbox"
              className={`py-3 text-gray-700 ${
                url === "/company/inbox" ? "border-l-4 border-green-600" : ""
              }`}
            >
              <span className="mr-1 ml-4">📥</span> Inbox{" "}
              <span className="ml-1 bg-red-500 text-white rounded-full px-2 text-xs">
                1
              </span>
            </Link>
            <Link
              to="#"
              className={`py-3 text-gray-700 ${
                url === "/company/edit-page"
                  ? "border-l-4 border-green-600"
                  : ""
              }`}
            >
              <span className="mr-1 ml-4">✏️</span> Edit page
            </Link>
            <Link
  to="/company/product-listing"
  className={`py-3 text-gray-700 ${
    url === "/company/product-listing" || url.startsWith("/company/product-description")
      ? "border-l-4 border-green-600"
      : ""
  }`}
>
  <span className="mr-1 ml-4">📦</span> Products
</Link>

            <Link
              to="#"
              className={`py-3 text-gray-700 ${
                url === "/company/jobs" ? "border-l-4 border-green-600" : ""
              }`}
            >
              <span className="mr-1 ml-4">👥</span> Jobs
            </Link>
            <Link
              to="#"
              className={`py-3 text-gray-700 ${
                url === "/company/newsletter"
                  ? "border-l-4 border-green-600"
                  : ""
              }`}
            >
              <span className="mr-1 ml-4">📰</span> Newsletters
            </Link>
            <Link
              to="#"
              className={`py-3 text-gray-700 ${
                url === "/company/premium-setup"
                  ? "border-l-4 border-green-600"
                  : ""
              }`}
            >
              <span className="mr-1 ml-4">⭐</span> Try Premium Page
            </Link>
            <Link
              to="#"
              className={`py-3 text-gray-700 ${
                url === "/company/advertisement"
                  ? "border-l-4 border-green-600"
                  : ""
              }`}
            >
              <span className="mr-1 ml-4">📣</span> Advertise
            </Link>
            <Link
              to="#"
              className={`py-3 text-gray-700 ${
                url === "/company/invite" ? "border-l-4 border-green-600" : ""
              }`}
            >
              <span className="mr-1 ml-4">➕</span> Invite to follow
            </Link>
            <Link
              to="#"
              className={`py-3 text-gray-700 ${
                url === "/company/setting" ? "border-l-4 border-green-600" : ""
              }`}
            >
              <span className="mr-1 ml-4">⚙️</span> Settings
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
